<template>
  <div class="loader mt-220" v-if="loading">
    <b-spinner label="Spinning" variant="primary"></b-spinner>
  </div>
  <div class="w-100 mt-80" v-else>
    <div class="article">
      <div class="article-width">
        <b-row class="article-img">
          <b-col cols="12">
            <div class="img-wrapper">
              <div class="img-holder image-block">
                <img :src="story.picture" class="img-fluid img-responsive contain image-content" alt="">
              </div>
            </div>
          </b-col>
        </b-row>
        <span style="width: 196px; display: block; margin-left: auto; margin-right: auto; margin-bottom: 16px;">Поделиться:</span>
        <div class="d-flex justify-content-center align-items-center">
          <ShareNetwork
            class="mr-2 pointer share-png"
            network="telegram"
            :url="currentPath"
            :title="story.title">
            <img :src="require('@/assets/telegram.png')" alt="">
          </ShareNetwork>
          <ShareNetwork
            class="mr-2 pointer share-png"
            network="facebook"
            :url="currentPath"
            :title="story.title"
          >
            <img :src="require('@/assets/facebook.png')" alt="">
          </ShareNetwork>
          <ShareNetwork
            class="mr-2 pointer share-png"
            network="whatsapp"
            :url="currentPath"
            :title="story.title">
            <img :src="require('@/assets/viber2.png')" alt="">
          </ShareNetwork>
          <ShareNetwork
            class="pointer share-png"
            network="viber"
            :url="currentPath"
            :title="story.title">
            <img :src="require('@/assets/whatsapp.png')" alt="">
          </ShareNetwork>
        </div>
        <h1 class="article-title">{{story.title}}</h1>
        <pre  class="article-text"><p class="textWrap">{{story.text}}</p></pre>
      </div>
    </div>
    <Videos/>
    <Footer/>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Footer from '@/views/Home/components/Footer';
  import Videos from '@/views/Home/components/Videos';

  export default {
    metaInfo: {
      title: `Статьи`
    },
    name: "Story",
    components: { Footer, Videos },
    data() {
      return {
        story: null,
        loading: true,
        currentPath: null
      }
    },
    async mounted() {
      this.loading = true
      const id = this.$route.params.id
      this.story = await this.fetchStoryById(id)
      this.loading = false
      this.currentPath = window.location.href
    },
    computed: {
      ...mapGetters('stories', ['getStories'])
    },
    methods: {
      ...mapActions('stories', ['fetchStoryById'])
    }
  }
</script>

<style lang="scss">
  .share-png {
    img {
      width: 43px;
      margin-bottom: 40px;
    }
  }
  .pointer {
    cursor: pointer;
  }
  .textWrap {
    white-space: pre-wrap;
  }
  .article {
    font-family: 'Raleway', sans-serif;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 12px;
  }
  .article-img {
    max-width: 605px;
    margin-left: auto !important;
    margin-right: auto !important;
    display: block;
    justify-content: center;
    margin-bottom: 32px;
    margin-top: 64px;
  }
  .article-title {
    font-size: 32px;
    font-weight: 600;
    color: #1f1f1f;
    text-align: center;
  }
  .article-text {
    font-family: 'Raleway', sans-serif;
    margin-top: 24px;
    font-size: 16px;
    text-align: justify;
    .textWrap {
      line-height: 1.8;
    }
  }
  .article-width {
    max-width: 1100px;
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and (max-width: 768px){
    .article-title {
      font-size: 24px;
    }
  }
</style>